import { observer } from 'mobx-react-lite';
import { ClientAttachmentId } from 'owa-client-ids';
import { readingPaneStore } from 'owa-mail-reading-pane-store';
import { ItemReadingPane } from 'owa-mail-reading-pane-view';
import * as React from 'react';

export interface ItemAttachmentPreviewProps {
    attachmentId: ClientAttachmentId;
    onError: (errorMessage: string, error?: Error) => void;
    onLoad: () => void;
}

export default observer(function ItemAttachmentPreview(props: ItemAttachmentPreviewProps) {
    const onLoad = () => {
        props.onLoad();
    };
    const onLoadFailed = () => {
        props.onError('Loading item failed');
    };
    return (
        <ItemReadingPane
            itemId={props.attachmentId}
            isItemAttachment={true}
            itemReadingPaneViewState={readingPaneStore.itemPreviewPaneViewState}
            onLoad={onLoad}
            onLoadFailed={onLoadFailed}
        />
    );
});
